'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _awaitAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _require = require('buffer'),
    Buffer = _require.Buffer;

var abortable = require('abortable-iterator');

var _require2 = require('./constants'),
    CLOSE_TIMEOUT = _require2.CLOSE_TIMEOUT;

var toMultiaddr = require('libp2p-utils/src/ip-port-to-multiaddr');

var pTimeout = require('p-timeout');

var debug = require('debug');

var log = debug('libp2p:websockets:socket');
log.error = debug('libp2p:websockets:socket:error'); // Convert a stream into a MultiaddrConnection
// https://github.com/libp2p/interface-transport#multiaddrconnection

module.exports = function (stream) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var maConn = {
    sink: function sink(source) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (options.signal) {
                  source = abortable(source, options.signal);
                }

                _context2.prev = 1;
                _context2.next = 4;
                return stream.sink(_wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk;

                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _iteratorNormalCompletion = true;
                          _didIteratorError = false;
                          _context.prev = 2;
                          _iterator = _asyncIterator(source);

                        case 4:
                          _context.next = 6;
                          return _awaitAsyncGenerator(_iterator.next());

                        case 6:
                          _step = _context.sent;
                          _iteratorNormalCompletion = _step.done;
                          _context.next = 10;
                          return _awaitAsyncGenerator(_step.value);

                        case 10:
                          _value = _context.sent;

                          if (_iteratorNormalCompletion) {
                            _context.next = 18;
                            break;
                          }

                          chunk = _value;
                          _context.next = 15;
                          return Buffer.isBuffer(chunk) ? chunk : chunk.slice();

                        case 15:
                          _iteratorNormalCompletion = true;
                          _context.next = 4;
                          break;

                        case 18:
                          _context.next = 24;
                          break;

                        case 20:
                          _context.prev = 20;
                          _context.t0 = _context["catch"](2);
                          _didIteratorError = true;
                          _iteratorError = _context.t0;

                        case 24:
                          _context.prev = 24;
                          _context.prev = 25;

                          if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                            _context.next = 29;
                            break;
                          }

                          _context.next = 29;
                          return _awaitAsyncGenerator(_iterator.return());

                        case 29:
                          _context.prev = 29;

                          if (!_didIteratorError) {
                            _context.next = 32;
                            break;
                          }

                          throw _iteratorError;

                        case 32:
                          return _context.finish(29);

                        case 33:
                          return _context.finish(24);

                        case 34:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[2, 20, 24, 34], [25,, 29, 33]]);
                }))());

              case 4:
                _context2.next = 9;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](1);

                if (_context2.t0.type !== 'aborted') {
                  log.error(_context2.t0);
                }

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 6]]);
      }))();
    },
    source: options.signal ? abortable(stream.source, options.signal) : stream.source,
    conn: stream,
    localAddr: options.localAddr || (stream.localAddress && stream.localPort ? toMultiaddr(stream.localAddress, stream.localPort) : undefined),
    // If the remote address was passed, use it - it may have the peer ID encapsulated
    remoteAddr: options.remoteAddr || toMultiaddr(stream.remoteAddress, stream.remotePort),
    timeline: {
      open: Date.now()
    },
    close: function close() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var start, _maConn$remoteAddr$to, host, port;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                start = Date.now();
                _context3.prev = 1;
                _context3.next = 4;
                return pTimeout(stream.close(), CLOSE_TIMEOUT);

              case 4:
                _context3.next = 11;
                break;

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3["catch"](1);
                _maConn$remoteAddr$to = maConn.remoteAddr.toOptions(), host = _maConn$remoteAddr$to.host, port = _maConn$remoteAddr$to.port;
                log('timeout closing stream to %s:%s after %dms, destroying it manually', host, port, Date.now() - start);
                stream.destroy();

              case 11:
                _context3.prev = 11;
                maConn.timeline.close = Date.now();
                return _context3.finish(11);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[1, 6, 11, 14]]);
      }))();
    }
  };
  stream.socket.once && stream.socket.once('close', function () {
    // In instances where `close` was not explicitly called,
    // such as an iterable stream ending, ensure we have set the close
    // timeline
    if (!maConn.timeline.close) {
      maConn.timeline.close = Date.now();
    }
  });
  return maConn;
};